export default class StateConversationInfo{
    name;
    img;
    //ProtoConversationInfo
    conversationInfo = {};
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/model/stateConversationInfo.js